import CollectionComponent from './Collection/Collection'
import FiltersComponent from './Filters/Filters'
import ItemComponent from './Item/Item'
import ModalNewReleaseComponent from './ModalNewRelease/ModalNewRelease'
import ModalViewItemComponent from './ModalViewItem/ModalViewItem'
import TabBigMatchesComponent from './TabBigMatches/TabBigMatches'
import TabMatchesComponent from './TabMatches/TabMatches'
import TabReleasesComponent from './TabReleases/TabReleases'
import ModalMatchRequestComponent from './ModalMatchRequest/ModalMatchRequest'
import TabMatchingComponent from './TabMatching/TabMatching'
import TabMatchingDetailsComponent from './TabMatchingDetails/TabMatchingDetails'
import ModalViewMatchComponent from './ModalViewMatch/ModalViewMatch'
import TabMonitoringDetailsComponent from './TabMonitoringDetails/TabMonitoringDetails'
import ModalViewMonitoringComponent from './ModalViewMonitoring/ModalViewMonitoring'
import FormTrabGeneric from './GenericFormTrab/FormTrab/FormTrab';
import FormFP from './FormFP/FormFP'
import FormSoc from './FormSoc/FormSoc'
import FormGift from './FormGift/FormGift'
import FormTravel from './FormTravel/FormTravel'
import FormValues from './FormValues/FormValues'
import FormPepNatural from './FormPepNatural/FormPepNatural'
// import FormTrabMod from './smu/FormTrab/FormTrab';
import TabStockTradingComponent from './TabStockTrading/TabStockTrading'
import ModalViewStockTradingComponent from './ModalViewStockTrading/ModalViewStockTrading'
import ModalPdfViewerComponent from './ModalPdfViewer/ModalPdfViewer'

export const Collection = CollectionComponent
export const Filters = FiltersComponent
export const Item = ItemComponent
export const ModalNewRelease = ModalNewReleaseComponent
export const ModalViewItem = ModalViewItemComponent
export const TabBigMatches = TabBigMatchesComponent
export const TabMatches = TabMatchesComponent
export const TabReleases = TabReleasesComponent
export const ModalMatchRequest = ModalMatchRequestComponent
export const TabMatching = TabMatchingComponent
export const TabMatchingDetails = TabMatchingDetailsComponent
export const ModalViewMatch = ModalViewMatchComponent
export const TabMonitoringDetails = TabMonitoringDetailsComponent
export const ModalViewMonitoring = ModalViewMonitoringComponent
export const FormFPPage = FormFP
export const FormSocPage = FormSoc
export const FormGiftPage = FormGift
export const FormTravelPage = FormTravel
export const FormValuesPage = FormValues
export const FormPepNaturalPage = FormPepNatural
// export const FormTrabPage = FormTrabMod;
export const FormTrabGenPage = FormTrabGeneric;
export const TabStockTrading = TabStockTradingComponent
export const ModalViewStockTrading = ModalViewStockTradingComponent
export const ModalPdfViewer = ModalPdfViewerComponent